import { render, staticRenderFns } from "./aggiungiContatto.vue?vue&type=template&id=0cdabdc6"
import script from "./aggiungiContatto.vue?vue&type=script&lang=js"
export * from "./aggiungiContatto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports